// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type PatchElementContentMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  content: PrivateSchemaTypes.Scalars['String'];
}>;


export type PatchElementContentMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { patchContent: (
          { __typename?: 'TopicElementModel' }
          & Pick<PrivateSchemaTypes.TopicElementModel, 'id' | 'data'>
        ) }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type EndTopicEditingMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type EndTopicEditingMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'endEditing' | 'id'>
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type FetchTopicToStartEditingQueryVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type FetchTopicToStartEditingQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type TopicForEditingQueryVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type TopicForEditingQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id' | 'currentTitle' | 'workspace_id' | 'deleted_at' | 'lastPublishedDate' | 'firstPublishedDate' | 'allow_comments' | 'latestPublishedTopicVersion'>
    & { feedbacksCount: PrivateSchemaTypes.TopicModelAsEditor['enrolmentsCount'] }
    & { currentTopicEditorUser?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'email' | 'display_name'>
    )>, workspace?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'WorkspaceModelAsCollaborator' }
      & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id' | 'name'>
    )>, currentTopicVersionAsEditor?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id' | 'title' | 'summary' | 'max_attempts' | 'readDurationMins' | 'manual_duration' | 'topic_type' | 'number_quizzes' | 'allow_retry' | 'version' | 'pass_mark'>
      & { scormCourse?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'ScormCourseModel' }
        & Pick<PrivateSchemaTypes.ScormCourseModel, 'id' | 'file_details' | 'status'>
      )>, publishedElements?: PrivateSchemaTypes.Maybe<Array<(
        { __typename?: 'TopicElementModel' }
        & Pick<PrivateSchemaTypes.TopicElementModel, 'id' | 'type' | 'duration' | 'data' | 'order'>
        & { quizOptions: Array<(
          { __typename?: 'QuizOptionModel' }
          & Pick<PrivateSchemaTypes.QuizOptionModel, 'id' | 'content' | 'feedback' | 'order' | 'is_correct'>
        )>, documents: Array<(
          { __typename?: 'VideoDocument' }
          & Pick<PrivateSchemaTypes.VideoDocument, 'id' | 'status' | 'fileUrl' | 'cdnUrl'>
        )> }
      )>>, backgroundImage?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'cdnUrl'>
      )> }
    )>, draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id' | 'title' | 'summary' | 'manual_duration' | 'readDurationMins' | 'topic_type' | 'number_quizzes' | 'allow_retry' | 'pass_mark' | 'max_attempts' | 'updated_at'>
      & { scormCourse?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'ScormCourseModel' }
        & Pick<PrivateSchemaTypes.ScormCourseModel, 'id' | 'file_details' | 'status'>
      )>, elements: Array<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id' | 'type' | 'duration' | 'data' | 'order'>
        & { quizOptions: Array<(
          { __typename?: 'QuizOptionModelAsEditor' }
          & Pick<PrivateSchemaTypes.QuizOptionModelAsEditor, 'id' | 'content' | 'feedback' | 'order' | 'is_correct'>
        )>, documents: Array<(
          { __typename?: 'VideoDocument' }
          & Pick<PrivateSchemaTypes.VideoDocument, 'id' | 'status' | 'fileUrl' | 'cdnUrl'>
        )> }
      )>, backgroundImage?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'cdnUrl'>
      )> }
    )>, relatedPathways: Array<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'title'>
    )>, author: (
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'profile_img_url'>
    ) }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle' | 'workspace_id' | 'deleted_at' | 'lastPublishedDate' | 'firstPublishedDate' | 'allow_comments' | 'latestPublishedTopicVersion'>
    & { author: (
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'profile_img_url'>
    ) }
  )> }
);


export const PatchElementContentDocument = gql`
    mutation patchElementContent($topicId: PositiveInt!, $elementId: PositiveInt!, $content: String!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          patchContent(content: $content) {
            id
            data
          }
        }
      }
    }
  }
}
    `;
export type PatchElementContentMutationFn = Apollo.MutationFunction<PatchElementContentMutation, PatchElementContentMutationVariables>;

/**
 * __usePatchElementContentMutation__
 *
 * To run a mutation, you first call `usePatchElementContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchElementContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchElementContentMutation, { data, loading, error }] = usePatchElementContentMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function usePatchElementContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PatchElementContentMutation, PatchElementContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PatchElementContentMutation, PatchElementContentMutationVariables>(PatchElementContentDocument, options);
      }
export type PatchElementContentMutationHookResult = ReturnType<typeof usePatchElementContentMutation>;
export type PatchElementContentMutationResult = Apollo.MutationResult<PatchElementContentMutation>;
export type PatchElementContentMutationOptions = Apollo.BaseMutationOptions<PatchElementContentMutation, PatchElementContentMutationVariables>;
export const EndTopicEditingDocument = gql`
    mutation endTopicEditing($topicId: PositiveInt!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      endEditing
    }
  }
}
    `;
export type EndTopicEditingMutationFn = Apollo.MutationFunction<EndTopicEditingMutation, EndTopicEditingMutationVariables>;

/**
 * __useEndTopicEditingMutation__
 *
 * To run a mutation, you first call `useEndTopicEditingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndTopicEditingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endTopicEditingMutation, { data, loading, error }] = useEndTopicEditingMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useEndTopicEditingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EndTopicEditingMutation, EndTopicEditingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EndTopicEditingMutation, EndTopicEditingMutationVariables>(EndTopicEditingDocument, options);
      }
export type EndTopicEditingMutationHookResult = ReturnType<typeof useEndTopicEditingMutation>;
export type EndTopicEditingMutationResult = Apollo.MutationResult<EndTopicEditingMutation>;
export type EndTopicEditingMutationOptions = Apollo.BaseMutationOptions<EndTopicEditingMutation, EndTopicEditingMutationVariables>;
export const FetchTopicToStartEditingDocument = gql`
    query fetchTopicToStartEditing($topicId: PositiveInt!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
      }
    }
  }
}
    `;

/**
 * __useFetchTopicToStartEditingQuery__
 *
 * To run a query within a React component, call `useFetchTopicToStartEditingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTopicToStartEditingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTopicToStartEditingQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useFetchTopicToStartEditingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchTopicToStartEditingQuery, FetchTopicToStartEditingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchTopicToStartEditingQuery, FetchTopicToStartEditingQueryVariables>(FetchTopicToStartEditingDocument, options);
      }
export function useFetchTopicToStartEditingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchTopicToStartEditingQuery, FetchTopicToStartEditingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchTopicToStartEditingQuery, FetchTopicToStartEditingQueryVariables>(FetchTopicToStartEditingDocument, options);
        }
export type FetchTopicToStartEditingQueryHookResult = ReturnType<typeof useFetchTopicToStartEditingQuery>;
export type FetchTopicToStartEditingLazyQueryHookResult = ReturnType<typeof useFetchTopicToStartEditingLazyQuery>;
export type FetchTopicToStartEditingQueryResult = Apollo.QueryResult<FetchTopicToStartEditingQuery, FetchTopicToStartEditingQueryVariables>;
export const TopicForEditingDocument = gql`
    query TopicForEditing($topicId: PositiveInt!) {
  topic(id: $topicId) {
    id
    currentTitle
    workspace_id
    deleted_at
    author {
      id
      display_name
      profile_img_url
    }
    lastPublishedDate
    firstPublishedDate
    allow_comments
    latestPublishedTopicVersion
    ... on TopicModelAsEditor {
      currentTopicEditorUser {
        id
        email
        display_name
      }
      workspace {
        id
        name
      }
      feedbacksCount: enrolmentsCount(filters: [{name: withFeedback}])
      currentTopicVersionAsEditor {
        id
        title
        summary
        max_attempts
        readDurationMins
        manual_duration
        topic_type
        number_quizzes
        allow_retry
        version
        pass_mark
        scormCourse {
          id
          file_details
          status
        }
        publishedElements {
          id
          type
          duration
          data
          order
          quizOptions {
            id
            content
            feedback
            order
            is_correct
          }
          documents {
            id
            status
            fileUrl
            cdnUrl
          }
        }
        backgroundImage {
          cdnUrl
        }
      }
      draftVersion(lockForEditing: false) {
        id
        title
        summary
        manual_duration
        readDurationMins
        topic_type
        number_quizzes
        allow_retry
        pass_mark
        max_attempts
        scormCourse {
          id
          file_details
          status
        }
        elements {
          id
          type
          duration
          data
          order
          quizOptions {
            id
            content
            feedback
            order
            is_correct
          }
          documents {
            id
            status
            fileUrl
            cdnUrl
          }
        }
        backgroundImage {
          cdnUrl
        }
        updated_at
      }
      relatedPathways {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useTopicForEditingQuery__
 *
 * To run a query within a React component, call `useTopicForEditingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicForEditingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicForEditingQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useTopicForEditingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TopicForEditingQuery, TopicForEditingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TopicForEditingQuery, TopicForEditingQueryVariables>(TopicForEditingDocument, options);
      }
export function useTopicForEditingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopicForEditingQuery, TopicForEditingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TopicForEditingQuery, TopicForEditingQueryVariables>(TopicForEditingDocument, options);
        }
export type TopicForEditingQueryHookResult = ReturnType<typeof useTopicForEditingQuery>;
export type TopicForEditingLazyQueryHookResult = ReturnType<typeof useTopicForEditingLazyQuery>;
export type TopicForEditingQueryResult = Apollo.QueryResult<TopicForEditingQuery, TopicForEditingQueryVariables>;